import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../../img/speech-bubble.svg'


const _hoisted_1 = {
  class: "card flex-column flex-lg-row w-100 h-100",
  id: "Personal__Help"
}
const _hoisted_2 = { class: "d-flex flex-column justify-content-center flex-grow-1 p-2" }
const _hoisted_3 = { class: "fw-bold font-size-md mb-1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Search our Help Center ")
const _hoisted_5 = { class: "input-group-append" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search me-1" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.axxess.com/help/",
  target: "_blank",
  class: "align-self-start ps-1"
}, " Visit Axxess Help Center ", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.axxess.com/help/search/?q=having%20trouble%20logging%20in",
  target: "_blank",
  class: "align-self-start ps-1"
}, " Having Trouble Logging In? ", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://community.axxessweb.com/",
  target: "_blank",
  class: "community-link"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-2 d-flex flex-column justify-content-center text-white" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-md fw-bold" }, " Axxess Community "),
    /*#__PURE__*/_createElementVNode("span", null, " Speak with fellow Axxessians ")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: _normalizeClass(["input-group", { 'has-value': !!_ctx.enableSearch }])
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Type and Click Search",
            onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.enterKeyPress && _ctx.enterKeyPress(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.helpSearch) = $event))
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelText, _ctx.helpSearch]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("button", {
              class: "btn clear-search",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
            }, _hoisted_7, 512 /* NEED_PATCH */), [
              [_vShow, _ctx.enableSearch]
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: !_ctx.enableSearch,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.helpCenterSearch && _ctx.helpCenterSearch(...args)))
            }, _hoisted_11, 8 /* PROPS */, _hoisted_8)
          ])
        ], 2 /* CLASS */)
      ]),
      _hoisted_12,
      _hoisted_13
    ]),
    _hoisted_14
  ]))
}